import { Form, ConfigProvider, Input, Switch } from 'antd';
import { useTranslation } from 'translations/hooks';

import { useGraphqlApiHeaders } from 'business/contextProviders/useApiHeaders';
import { usePermissions } from 'business/contextProviders/usePermissions';
import {
  useProdAndPerfFilters,
  useProdAndPerfFiltersFormName,
} from 'business/production-and-performance/providers/prod-and-perf-filters-provider';
import { Module_Enum, useGetCurrentRingQuery } from 'generated/graphql';
import {
  PreselectRingRangeInput,
  PreselectRingRangeTypeEnum,
} from 'ui/form/preselect-ring-range-input';

export interface ExcavationBuildTimeMobileFilterProps {}

export const ExcavationBuildTimeMobileFilters =
  ({}: ExcavationBuildTimeMobileFilterProps) => {
    const { t } = useTranslation();
    const formName = useProdAndPerfFiltersFormName();
    const filters = useProdAndPerfFilters();
    const [form] = Form.useForm();

    const { constructionSiteId } = usePermissions();
    const headers = useGraphqlApiHeaders(Module_Enum.ProdPerf);

    const { data, error } = useGetCurrentRingQuery({
      variables: { constructionSiteId },
      context: {
        headers,
      },
    });

    return (
      <ConfigProvider
        theme={{
          components: {
            Form: {
              inlineItemMarginBottom: 12,
            },
          },
        }}
      >
        <Form
          layout="inline"
          form={form}
          name={formName}
          initialValues={filters}
        >
          <Form.Item name="filterType" hidden>
            <Input disabled />
          </Form.Item>

          <Form.Item name="ringRange" label={t('input.ringRange.label')}>
            <PreselectRingRangeInput
              defaultType={PreselectRingRangeTypeEnum.LastFifty}
              lastRing={
                data?.parameter_ring_aggregate.aggregate?.max?.ringNumber
              }
              error={!!error}
            />
          </Form.Item>

          <Form.Item
            name="showTotalDurations"
            label={t(
              'productionAndPerformance.excavationBuildTime.filters.toggleTotalAverages',
            )}
          >
            <Switch size="small" />
          </Form.Item>
        </Form>
      </ConfigProvider>
    );
  };
